import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import Landing from './pages/Landing';
import Login from './pages/Login';
import Register from './pages/Register';
import Products from './pages/Products';
import ProductDetail from './pages/ProductDetail';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import Orders from './pages/Orders';
import OrderSuccess from './pages/OrderSuccess';
import Membership from './pages/Membership';
import MembershipSuccess from './pages/MembershipSuccess';
import BrandDashboard from './pages/BrandDashboard';
import BrandRegister from './pages/BrandRegister';
import UploadProduct from './pages/UploadProduct';
import BulkUpload from './pages/BulkUpload';
import AdminDashboard from './pages/AdminDashboard';
import FlashSaleManager from './pages/FlashSaleManager';
import './App.css';

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/products" element={<Products />} />
          <Route path="/products/:id" element={<ProductDetail />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/orders" element={<Orders />} />
          <Route path="/orders/success" element={<OrderSuccess />} />
          <Route path="/membership" element={<Membership />} />
          <Route path="/membership/success" element={<MembershipSuccess />} />
          <Route path="/brand/register" element={<BrandRegister />} />
          <Route path="/brand/dashboard" element={<BrandDashboard />} />
          <Route path="/brand/upload" element={<UploadProduct />} />
          <Route path="/brand/bulk-upload" element={<BulkUpload />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/flash-sales" element={<FlashSaleManager />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </>
  );
}

export default App;
